import React from 'react';
import SectionCard from './SectionCard';
import { useLanguage } from '../context/LanguageContext';

const AboutSection = ({ isDoorOpen }) => {
  const { t } = useLanguage();

  return (
    <SectionCard
      id="apropos"
      icon="🔑"
      title={t.about.title}
      subtitle={t.about.subtitle}
      isDoorOpen={isDoorOpen}
    >
      <div className="grid-2">
        <div>
          <p>{t.about.bio}</p>
        </div>
        <div>
          {t.about.expertise.map((exp, index) => (
            <div key={index} className="pill">
              {exp}
            </div>
          ))}
        </div>
      </div>
    </SectionCard>
  );
};

export default AboutSection;
